export default class PhoneCallStatus {
    static get New () { return 'new' }
    static get Answer () { return 'answer' }
    static get Completed () { return 'completed' }
    static get Canceled () { return 'canceled' }
}
